module.exports = __webpack_public_path__ + "static/media/tokyo-green-down.e831dd19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/tokyo-green-down.svg
// module id = 107
// module chunks = 0